import BabelSnippet from 'content/snippets/main/gatsby-babel';
import WebpackSnippet from 'content/snippets/main/gatsby-webpack';
import ActStructureSnippet from 'content/snippets/main/act-structure';
import ImportSnippet from 'content/snippets/main/mdx-import';
import ActHelperSnippet from 'content/snippets/main/act-helper';
import React from 'react';
import { MDXTag } from '@mdx-js/tag';
export default {
  BabelSnippet,
  WebpackSnippet,
  ActStructureSnippet,
  ImportSnippet,
  ActHelperSnippet,
  React,
  MDXTag
};